const c = {
  name: "Xcode1",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30.1,4.2c0.7,0.3,1.3,0.9,1.6,1.6l0,0c0.3,0.8,0.3,1.6,0,2.3l-1.1,2.8c-0.3,0.7-0.9,1.3-1.6,1.6
			c-0.4,0.1-0.8,0.2-1.2,0.2s-0.8-0.1-1.1-0.2l-1.8-0.8l0.4-0.9c0.1-0.2,0.1-0.5,0-0.8c-0.1-0.2-0.3-0.4-0.5-0.5L24,11.2V21
			c0,2.8-2.2,5-5,5h-1.2c-0.4,1-1.2,1.7-2.2,2c-0.3,0.1-0.6,0.1-1,0.1c-1.2,0-2.4-0.7-3-1.8c0-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1
			H5c-2.8,0-5-2.2-5-5V7c0-2.8,2.2-5,5-5h10c0.5-0.7,1.2-1.3,2.1-1.6c1.3-0.5,2.6-0.5,3.8,0l3.7,1.5c0.7,0.3,1.3,0.9,1.6,1.6
			c0.2,0.4,0.2,0.9,0.2,1.3l0.1,0.1c0.5,0.2,1.1,0,1.3-0.5l0.4-0.9L30.1,4.2z M2,7v14l0,0c0,1.6,1.4,3,3,3h6.3
			c0-0.3,0.1-0.5,0.3-0.8L14,18H9.6l-2.3,3.5l-1.7-1.1L7.2,18H6v-2h2.5l2.3-3.6L7.7,7.5l1.7-1.1l2.7,4.1l2.7-4.1l1.7,1.1l-3.1,4.9
			l2,3.1l3.1-6.5l-0.9-0.4l0.4-0.9C18,7.5,18,7.2,17.8,6.9c-0.4-0.9-1.5-1.9-2.9-2.5L14,4H5C3.4,4,2,5.4,2,7z M10.9,16h2.2L12,14.3
			L10.9,16z M15,26.1c0.4-0.1,0.8-0.5,0.9-0.9h0l5.2-14.9l-1-0.4l-6.9,14.3c-0.2,0.4-0.2,0.9,0,1.3C13.7,26,14.4,26.3,15,26.1z
			 M18.5,24H19c1.7,0,3-1.4,3-3v-6.9L18.5,24z M28.8,10.1l1.1-2.8v0c0.1-0.2,0.1-0.5,0-0.8c-0.1-0.2-0.3-0.4-0.5-0.5L29.2,6
			c-0.8,0.9-2.2,1.3-3.4,0.8L24,6l0.4-0.9c0.1-0.2,0.1-0.5,0-0.8c-0.1-0.2-0.3-0.4-0.5-0.5l-3.7-1.5c-0.7-0.3-1.5-0.3-2.3,0
			c-0.4,0.2-0.8,0.5-1.1,0.8c1.4,0.8,2.4,1.9,2.9,3c0.2,0.5,0.3,1,0.3,1.5l0.3,0.1l2.7,1.1l0.8-1.8l1.8,0.8c0.8,0.3,1.3,0.9,1.6,1.6
			c0.2,0.4,0.2,0.9,0.2,1.3l0.1,0.1c0.2,0.1,0.5,0.1,0.8,0C28.5,10.6,28.7,10.4,28.8,10.1z"/>
		<path class="st0" d="M9,30h4v8h2v2H9v-2h2v-6H9V30z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Xcode1
};
